import React from 'react';
import { Card } from 'react-bootstrap';
import { Button, Col, Row } from 'react-bootstrap';

import SingleLeyendLabel from '../../../../support/SingleLeyendLabel';

const ComplementoImpuestosLocalesResumen = ({ data = {}, onEdit, onDelete }) => {

  const handleOnDelete = () => {
    onDelete('ImpuestosLocales');
  }

  const handleOnEdit = () => {
    onEdit('ImpuestosLocales', data);
  }

  const renderLeyends = (data, item, index = '') => {
    return (
      <SingleLeyendLabel
        key={ index.toString() + item.index }
        label={ item.label }
        index={ item.index }
        data={ data }
        render={ item.render }
      />
    )
  }

  return (
    <Card>
      <Card.Body>
        <Card.Subtitle className="text-center">
          Impuestos Locales
        </Card.Subtitle>

        <Row className="py-3">
          <Col sm md="6">
            { labels.map(renderLeyends.bind(null, data)) }
          </Col>
        </Row>

        { data.RetencionesLocales?.length > 0 && (
          <>
            <strong className="text-muted">Retenciones Locales</strong>

            <Row className="py-3">
              <Col>
                { (data.RetencionesLocales || []).map((data, index) => {
                    return retencionesLocalesLabels.map(item => renderLeyends(data, item, index.toString()));
                  }
                )}
              </Col>
            </Row>
          </>
        )}

        { data.TrasladosLocales?.length > 0 && (
          <>
            <strong className="text-muted">Traslados Locales</strong>

            <Row className="py-3">
              <Col>
                { (data.TrasladosLocales || []).map((data, index) => {
                    return trasladosLocalesLabels.map(item => renderLeyends(data, item, index.toString()));
                  }
                )}
              </Col>
            </Row>
          </>
        )}

        <Row>
          <Col>
            <Button variant="danger"
              className="mr-3"
              onClick={ handleOnDelete }
            >
              Quitar
            </Button>

            <Button variant="secondary"
              onClick={ handleOnEdit }
            >
              Editar
            </Button>
          </Col>
        </Row>

      </Card.Body>
    </Card>
  )
}

export default ComplementoImpuestosLocalesResumen;

const labels = [
  {
    label: 'Total de Retenciones',
    index: 'TotaldeRetenciones',
    col: 1
  },
  {
    label: 'Total de Traslados',
    index: 'TotaldeTraslados',
    col: 1
  },
];

const retencionesLocalesLabels = [
  {
    label: 'Imp. Loc. Retenido',
    index: 'ImpLocRetenido',
  },
  {
    label: 'Tasa de Retencion',
    index: 'TasadeRetencion',
  },
  {
    label: 'Importe',
    index: 'Importe',
  }
];

const trasladosLocalesLabels = [
  {
    label: 'Imp. Loc. Trasladado',
    index: 'ImpLocTrasladado',
  },
  {
    label: 'Tasa de Traslado',
    index: 'TasadeTraslado',
  },
  {
    label: 'Importe',
    index: 'Importe',
  }
];